export default "__VITE_ASSET__9DoSlI42__"